<template>
  <div :class="{ 'xl:[column-span:all]': isFullWidth }" class="break-inside-avoid">
    <div class="mx-0 3xl:mx-auto" :class="{ '3xl:max-w-5xl': !isFullWidth }">
      <div
        class="mb-4 bg-white shadow sm:mb-5 sm:rounded-lg md:mb-8 xl:mx-auto"
        :class="{ 'xl:max-w-5xl': !isFullWidth, 'xl:mt-8': isFullWidth }"
      >
        <LandingCardTitle :title="title" :view-all-to="viewAllTo" v-if="title || $slots.title">
          <slot name="title" v-if="$slots.title"></slot>
        </LandingCardTitle>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import LandingCardTitle from "./LandingCardTitle.vue";
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

export default defineComponent({
  name: "LandingCard",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    viewAllTo: {
      type: Object as PropType<string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric>,
      required: false,
      default: null,
    },
    isFullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    LandingCardTitle,
  },
});
</script>
